import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['open', 'content']

  className () {
    return this.element.dataset.classname
  }

  open () {
    this.openTarget.style.display = 'none'
    this.contentTarget.style.display = 'block'
  }
}
